import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import { fontStyle } from '@/css/resources/mixins.css';
import {
	wrapperStyles,
	inputSizeStyles,
	inputSizeEditStyles,
} from '@/css/shared/inputs.css';

const getDynamicStyles = (formStyles) =>
	cssObj(wrapperStyles(formStyles), inputSizeStyles(), {
		'.supt-inputYesNo__title': fontStyle({
			...formStyles?.checkbox?.subtitle?.typography,
			textAlign: formStyles?.checkbox?.subtitle?.textAlignment,
			color: formStyles?.checkbox?.subtitle?.color,
		}),
	});

const getStyles = (formStyles) =>
	css(getDynamicStyles(formStyles), {
		// maxWidth: '400px',

		'.supt-inputCheckbox': {
			marginTop: '0px !important',
		},
	});

const getEditGlobalStyles = () =>
	cssObj({
		'.wp-block[data-type="supt/input-yesno"]': inputSizeEditStyles(),
	});

export { getStyles, getEditGlobalStyles };
